import type {
  DropdownComponentTheme,
  GeneratedTheme,
  Theme,
} from '../../types';

type Props = {
  core: Theme['core'];
  semantic: Theme['semantic'];
  components: GeneratedTheme['components'];
};

const mapDropdownTheme = ({
  core,
  components,
}: Props): DropdownComponentTheme => ({
  ListItem: {
    ...components.DropdownListItem.regular,
    'font-size': core.typography.fontSize.md,
  },
  List: components.Dropdown.regular['dropdown list'],
  stack: components.Dropdown.regular.stack,
});

export default mapDropdownTheme;
